$(document).ready(function(){
    // ----------------------------------------------------------------------------
    // Setup Variables
    var windowWidth = $(window).width();
    var oHeaderContainer = $('#header');
    oHeaderContainer.data('curwidth', windowWidth);

    // Load on init
    setWidth();
    setupMenu();

    // Window resizing
    $(window).resize(function() {
        setWidth();
        setupMenu();
    });

    //----------------------------------------------------------------------------
    // Mega menu
    var $mega = $('.mega-menu');
    var $studentMega = $('.student-mega');
    var $studentItem = $studentMega.find('.menu-controls li');
    var $trigger = $('.trigger');
    var $bodyTag = $('body');

    $($trigger).on('click', function(e){
        e.preventDefault();
        var $whichMenu = $(this).data('trigger');
        var $currentMenu = $('.'+ $whichMenu);

        // Toggle the current open menu to closed so that only one menu is open
        $('li.open').not($(this)).removeClass('open').addClass('closed');
        $(this).toggleClass("open closed");

        // Open the current click menu
        if ($currentMenu.hasClass('open')) {
            $currentMenu.removeClass('open');
        } else {
            $mega.removeClass('open');
            $currentMenu.addClass('open');
        }
        $bodyTag.toggleClass('mega-menu-open');
    });
    //----------------------------------------------------------------------------
    // Click action on the menu titles in the primart navigation start
    var $menuTitle = $('.menu-title');

    $($menuTitle).on('click', function(e){
        if (windowWidth <= 1025) {
            e.preventDefault();
            $('.menu-title.active').not($(this)).trigger('click');
            $('.heater-header.active').trigger('click');
            $(this).toggleClass('active');
            $(this).next('ul').slideToggle('fast');
            $(this).next('.toggle-wrapper').slideToggle('fast');
            $(this).next('.icon-wrapper').toggleClass('open');
        }
    });
    //----------------------------------------------------------------------------
    // Click action on student nav root headers start
    $('.root-menu-title').on('click', function(e){
        e.preventDefault();
        if (windowWidth <= 1025) {
            var $nextCol = $(this).nextAll('.column').find('.student-toggle');

            $('.root-menu-title.active').not($(this)).trigger('click');
            $(this).toggleClass('active');
            $(this).parent().find('.account-list').slideToggle('fast');
            $nextCol.toggleClass('open');
            $nextCol.next('ul').slideUp('fast');
            $nextCol.removeClass('active');
        }
    });
    //----------------------------------------------------------------------------
    // Click action student nav Nested Headers start
    $('.student-toggle').on('click', function(e){
        e.preventDefault();
        if (windowWidth <= 1025) {
            $(this).toggleClass('active');
            $(this).next('ul').slideToggle('fast');
        }
    });
    //----------------------------------------------------------------------------
    // Click action Headers in the heater start
    $('.heater-header').on('click', function(e){
        e.preventDefault();
        if (windowWidth <= 1025) {
            $('.heater-header.active').not($(this)).trigger('click');
            $('.menu-title.active').trigger('click');
            $(this).toggleClass('active');
            $(this).next('.lists').slideToggle('fast');
            $(this).next('.icon-wrapper').toggleClass('open');
            $(this).next('.toggle-wrapper').toggleClass('open');
        }
    });
    //----------------------------------------------------------------------------
    // Click action on a Search Header on mobile start
    $('.search-header').on('click', function(e){
        e.preventDefault();
        if (windowWidth <= 1025) {
            $(this).toggleClass('active');
            $(this).nextAll('.small-24').find('ul').slideToggle('fast');
        }
    });
    //----------------------------------------------------------------------------
    // Switching the Student Navigation per audience start
    $studentItem.on('click', function(){
        var $targetMenu = $(this).data('target');
        $('.custom-menu').removeClass('active');
        $("[data-menu='" + $targetMenu + "']").addClass('active');
        $studentItem.not($(this)).removeClass('active');
        $(this).addClass("active");
    });
    //----------------------------------------------------------------------------
    // To close menu when click outside menu start
    $('html').click(function() {
        $('.mega-menu').removeClass('open');
        $('.trigger').removeClass('open').addClass('closed');
    });

    $('.trigger, .mega-menu, .search-root, .heater').click(function(event){
        event.stopPropagation();
    });
    //----------------------------------------------------------------------------
    // ~~~~~~~~~~~ FUNCTIONS ~~~~~~~~~~~~ //
    function setWidth() {
        windowWidth = $(window).width();
    }

    function setupMenu() {
        var $nextCol = $('.root-menu-title').nextAll('.column').find('.student-toggle');
        var $rootMenu = $('.root-menu-title');
        var $menuTitle = $('.menu-title');
        var $heaterHeader = $('.heater-header');

        var currentDocWidth = oHeaderContainer.data('curwidth');
        if (currentDocWidth != windowWidth) {
            if (windowWidth > 1025) {
                // Primary Menu Reset Desktop
                $menuTitle.next('ul').show();
                $menuTitle.next('.toggle-wrapper').show();

                // Student Menu Reset Desktop
                $rootMenu.parent().find('.account-list').show();
                $nextCol.next('ul.desktop-list').show();

                // Heater Menu Reset Desktop
                $heaterHeader.next('.lists').show();
                $heaterHeader.next('.icon-wrapper').show();
                $heaterHeader.next('.toggle-wrapper').show();

                // Search Menu Reset Desktop
                $('.search-header').nextAll('.small-24').find('ul').show();
            } else {
                // Primary Menu Reset Mobile
                $menuTitle.removeClass('active');
                $menuTitle.next('ul').hide();
                $menuTitle.next('.toggle-wrapper').hide();

                // Student Menu Reset Mobile
                $rootMenu.parent().find('.account-list').hide();
                $nextCol.next('ul.desktop-list').hide();
                $nextCol.next('ul').hide();
                $rootMenu.removeClass('active');
                $nextCol.removeClass('open');

                // Heater Menu Reset Mobile
                $heaterHeader.removeClass('active');
                $heaterHeader.next('.lists').hide();
                $heaterHeader.next('.icon-wrapper').hide();
                $heaterHeader.next('.toggle-wrapper').hide();

                // Search Menu Reset Desktop
                $('.search-header').nextAll('.small-24').find('ul').hide();
            }
        }
        oHeaderContainer.data('curwidth', windowWidth);
    }
});
